import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfileLittersSkeleton({ className }) {
  return (
    <div
      className={classnames('BreederProfileLittersSkeleton font-16', className)}
    >
      <div className="container-xxl mv8 mv20-md">
        <SkeletonBlock
          className="mb6 mb10-md font-24 md:font-40"
          height="1em"
          width="12em"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-24">
          {makeSequence(3).map(index => (
            <SkeletonBlock key={index} height="16em" width="100%" />
          ))}
        </div>
      </div>
    </div>
  );
}

BreederProfileLittersSkeleton.propTypes = {
  className: PropTypes.string
};

BreederProfileLittersSkeleton.defaultProps = {
  className: null
};
